import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Button } from 'primeng/button';

export interface ThreadDeleteConfirmationData {
  threadTitle: string;
  threadId: string;
}

export interface ThreadDeleteConfirmationResult {
  confirmed: boolean;
  threadId: string;
}

@Component({
  selector: 'selfai-platform-thread-delete-confirmation-dialog',
  standalone: true,
  imports: [CommonModule, TranslateModule, Button],
  templateUrl: './thread-delete-confirmation-dialog.component.html',
  styleUrls: ['./thread-delete-confirmation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreadDeleteConfirmationDialogComponent {
  public data: ThreadDeleteConfirmationData | undefined;

  constructor(
    private readonly ref: DynamicDialogRef,
    private readonly config: DynamicDialogConfig<ThreadDeleteConfirmationData>,
  ) {
    this.data = this.config.data;
  }

  public confirm(): void {
    const result: ThreadDeleteConfirmationResult = {
      confirmed: true,
      threadId: this.data?.threadId || '',
    };
    this.ref.close(result);
  }

  public cancel(): void {
    const result: ThreadDeleteConfirmationResult = {
      confirmed: false,
      threadId: this.data?.threadId || '',
    };
    this.ref.close(result);
  }
}
